/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COMMENTING ANALYTICS - TOTAL COMMENTS REPORT : STYLES --------------- ++++++++++ */
export default {
    toparticlesreport: {
        marginBottom: pxToEm(16)
    }
};
